import noop from "lib/noop"
import { InMemoryCache } from "@apollo/client"
import { FlushGraphQLCache, HasInvalidated, Invalidate, UserLoggedOut } from "event-definitions"
import { ensureArray } from "lib/ensure-array"
import { INVALIDATION_PARAMETER_DELIMITER } from "library/delimiter.mjs"

let cache

export function createCache() {
    cache = new InMemoryCache({
        typePolicies: {
            Schedule: {
                keyFields: ["id", "_id", "version", "code"],
            },
            Basket: {
                fields: {
                    items: {
                        merge(existing, incoming) {
                            return incoming
                        },
                    },
                },
            },
        },
    })
    return cache
}

FlushGraphQLCache.before.handle(async () => {
    await cache.reset({ discardWatches: false })
})

function removeFrom(target, startsWith, root, cb = noop) {
    if (!target) return
    for (const key of Object.keys(target)) {
        if (key.startsWith(startsWith)) {
            if (root) {
                cache.evict({ id: root, fieldName: key })
            } else {
                cache.evict({ id: key })
            }
            cb(key)
        }
    }
}

function removeFromById(target, id, root, cb = noop) {
    if (!target) return
    for (const key of Object.keys(target)) {
        if (key.includes(id)) {
            if (root) {
                cache.evict({ id: root, fieldName: key })
            } else {
                cache.evict({ id: key })
            }
            cb(key)
        }
    }
}

export function evict(startsWith, cb = noop) {
    if (!startsWith) return
    removeFrom(cache.data.data.ROOT_QUERY, startsWith, "ROOT_QUERY", cb)
    removeFrom(cache.data.data.ROOT_MUTATION, startsWith, "ROOT_MUTATION", cb)
    removeFrom(cache.data.data.ROOT_SUBSCRIPTION, startsWith, "ROOT_SUBSCRIPTION", cb)
    removeFrom(cache.data.data, startsWith, undefined, cb)
}

function evictId(id, cb = noop) {
    removeFromById(cache.data.data.ROOT_QUERY, id, "ROOT_QUERY", cb)
    removeFromById(cache.data.data.ROOT_MUTATION, id, "ROOT_MUTATION", cb)
    removeFromById(cache.data.data.ROOT_SUBSCRIPTION, id, "ROOT_SUBSCRIPTION", cb)
    removeFromById(cache.data.data, id, undefined, cb)
}

UserLoggedOut.handleOnce(() => {
    console.log("User Logged out")
    cache.reset()
})

FlushGraphQLCache.handleOnce(() => {
    evict("", (key) => {
        key = key.split("(")[0]
        HasInvalidated.raiseOnce(key)
        HasInvalidated(key).raiseOnce(key)
    })
})

Invalidate.handle((name) => {
    for (const query of ensureArray(name)) {
        if (query.includes(INVALIDATION_PARAMETER_DELIMITER)) {
            const [invalidateQuery, id] = query.split(INVALIDATION_PARAMETER_DELIMITER)
            evictId(id)
            // Clear the right cache
            HasInvalidated.raiseOnceDedupe(() => id, invalidateQuery, id)
            HasInvalidated(invalidateQuery).raiseOnceDedupe(() => id, invalidateQuery, id)
        } else {
            evict(query)
            HasInvalidated.raiseOnce(query)
            HasInvalidated(query).raiseOnce(query)
        }
    }
})

export function invalidate(name) {
    Invalidate.raise(name)
}
